export default "__VITE_ASSET__Bsm_Hdib__"